export const GuardSizes = {
    userAccessLogSize: 10,
    userInvitationSize: 10,
    eventSize: 10,
    vehicleAccessLogSize: 10,
    vehicleInvitationSize: 10,
    orderSize: 10,
    contractSize: 10,
};
